// Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faFoursquare,
  faGoogle,
  faInstagram,
  faLinkedin,
  faMedium,
  faPinterest,
  faTripadvisor,
  faTwitter,
  faUntappd,
  faVimeo,
  faYelp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

// Deep import so we don't need to import and tree/shake the whole collection
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown'
import { faCaretRight as faCaretRightSolid } from '@fortawesome/pro-solid-svg-icons/faCaretRight'
import { faTh as faThSolid } from '@fortawesome/pro-solid-svg-icons/faTh'
import { faTh as faThLight } from '@fortawesome/pro-light-svg-icons/faTh'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faStarHalfAlt } from '@fortawesome/pro-solid-svg-icons/faStarHalfAlt'
import { faStar as starReg } from '@fortawesome/pro-regular-svg-icons/faStar'
import { faSpinner as faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner'
import { faSearchPlus } from '@fortawesome/pro-light-svg-icons/faSearchPlus'
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch'
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
import { faMapMarkerAlt as faMapMarkerLight } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt'
import { faMapMarkerAlt as faMapMarkerSolid } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt'
import { faLocation as faLocationLight } from '@fortawesome/pro-light-svg-icons/faLocation'
import { faFileDownload as faFileDownloadLight } from '@fortawesome/pro-light-svg-icons/faFileDownload'
import { faVideo } from '@fortawesome/pro-light-svg-icons/faVideo'
import { faVrCardboard } from '@fortawesome/pro-light-svg-icons/faVrCardboard'
import { faCube } from '@fortawesome/pro-light-svg-icons/faCube'
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faTree,faShoppingBag, faShoppingBasket, faBookOpen } from '@fortawesome/pro-regular-svg-icons'

// add the imported icons to the library
library.add(
  faFacebook,
  faFoursquare,
  faGoogle,
  faInstagram,
  faLinkedin,
  faMedium,
  faPinterest,
  faTripadvisor,
  faTwitter,
  faUntappd,
  faVimeo,
  faYelp,
  faYoutube,
  faArrowLeft,
  faArrowRight,
  faChevronDown,
  faCaretRightSolid,
  faThLight,
  faThSolid,
  faMapMarkerLight,
  faMapMarkerSolid,
  faStar,
  faStarHalfAlt,
  starReg,
  faLocationLight,
  faSearchPlus,
  faPlus,
  faSearch,
  faSpinner,
  faFileDownloadLight,
  faVideo,
  faVrCardboard,
  faCube,
  faEye,
  faCircle,
  faTree,
  faShoppingBag,
  faShoppingBasket,
  faBookOpen
);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js